/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./TopicDetailsPanel.module.css"
import cx from "classnames"
import {ReactComponent as CloseIcon} from "./assets/close.svg"
import {Communication} from "types/communication"
import {TopicDetails} from "../TopicDetails"
import {useEffect, useState} from "react"

type Props = {
    topic?: Communication.ChannelTopic
    visible: boolean
    onClose: () => void
}

export default function TopicDetailsPanel(props: Props) {
    const {visible, onClose, topic: initialTopic} = props
    const [topic, setTopic] = useState<Communication.ChannelTopic | undefined>(initialTopic)

    useEffect(() => {
        setTopic(initialTopic)
    }, [initialTopic])

    if (!visible) return null

    return (
        <div className={styles.container}>
            <div className={cx(styles.section, styles.heading)}>
                <div className={styles.iconWrap} onClick={onClose}>
                    <CloseIcon className={styles.icon} />
                </div>
            </div>
            <div className={styles.threadWrap}>
                {topic && <TopicDetails topic={topic} composeClassName={styles.composeContainer} />}
            </div>
        </div>
    )
}
